module.exports = __webpack_public_path__ + "img/sfq-h2.3f2a1ba8.png";